import React from 'react'
import { Auth as AwsAuth } from 'aws-amplify'
import axios from 'axios'
import SessionService from '../../lib/services/SessionService'

class Auth extends React.Component {
    componentDidMount() {
        console.log('Auth component')
        // this component is a root component, check (from cache) if the user is logged
        AwsAuth.currentSession()
            .then(data => {
                //console.log('get cognito session:', data)
                let session = data

                //set token for all AXIOS REQUESTS
                axios.defaults.headers.common['Authentication'] = session.idToken.jwtToken

                let partnerMasquerading = SessionService.getPartnerMasqueraded()
                if (partnerMasquerading!=null && partnerMasquerading.partnerId) {
                    axios.defaults.headers.common['PartnerIdMasquerading'] = partnerMasquerading.partnerId
                }
            

                // also check if we have the special cookie from seller site to app site
                let partnerMasqueradingSeller = SessionService.getPartnerMasqueradedSeller()
                if (partnerMasqueradingSeller!=null && partnerMasqueradingSeller.partnerId) {
                    axios.defaults.headers.common['PartnerIdMasquerading'] = partnerMasqueradingSeller.partnerId
                }
            


            })
            .catch(err => {
                console.log('get cognito session error:', err)
            })
    }

    render() {
        return null
    }
}

export default Auth
